import React from "react";
import { Box, Typography } from "@mui/material";
import PendingIcon from "@mui/icons-material/Pending";
import ErrorIcon from "@mui/icons-material/Error";
import SellIcon from "@mui/icons-material/Sell";
import DoNotDisturbOnTotalSilenceIcon from "@mui/icons-material/DoNotDisturbOnTotalSilence";

const EventStatusView = ({ status, squareLocationError }) => {
  let statusText;
  let icon;
  let textColor = "text.primary";

  if (squareLocationError) {
    statusText = "Payment Error";
    icon = <ErrorIcon sx={{ height: "15px", width: "15px" }} color="error" />;
    textColor = "error";
  } else {
    switch (status) {
      case "draft":
        statusText = "Draft";
        icon = (
          <PendingIcon
            sx={{ height: "15px", width: "15px" }}
            color="disabled"
          />
        );
        break;

      case "pending":
        statusText = "Sale pending";
        icon = (
          <PendingIcon sx={{ height: "15px", width: "15px" }} color="warning" />
        );
        break;

      case "onSale":
        statusText = "On sale";
        icon = (
          <SellIcon sx={{ height: "15px", width: "15px" }} color="success" />
        );
        break;

      case "soldOut":
        statusText = "Sold out";
        icon = (
          <DoNotDisturbOnTotalSilenceIcon
            sx={{ height: "15px", width: "15px" }}
            color="error"
          />
        );
        break;

      case "ended":
        statusText = "Ended";
        icon = (
          <DoNotDisturbOnTotalSilenceIcon
            sx={{ height: "15px", width: "15px" }}
            color="disabled"
          />
        );
        break;
      default:
        statusText = "Unknown";
        icon = null;
        break;
    }
  }

  return (
    <Box
      display={"flex"}
      gap={"5px"}
      alignItems={"center"}
      sx={{ height: "100%" }}
    >
      {icon}
      <Typography variant="body2" color={textColor}>
        {statusText}
      </Typography>
    </Box>
  );
};

export default EventStatusView;
